import type { SVGProps } from "react";
const SvgShare08 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M21 6.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM9 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM21 17.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8.729 10.75l6.5-3m-6.5 5.5 6.5 3"
    />
  </svg>
);
export default SvgShare08;
